import styled from '@emotion/styled';

interface ChatBodyContentProps {
    heightValue: string;
}

export const StyledChatBodyNew = styled.div`
    flex-direction: column;
    align-items: stretch;
    position: relative;
    display: flex;
    flex-grow: 1;
`;

export const StyledChatBodyHeader = styled.div`
    justify-content: space-between;
    position: relative;
    padding: 12px 20px;
    display: flex;

    &:before {
        border-top: 2px solid #c0c0c0;
        position: absolute;
        display: block;
        content: '';
        width: 90%;
        left: 5%;
        bottom: 0;
    }
`;

export const StyledChatBodyHeaderTitle = styled.span`
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    top: 50%;
`;

export const StyledChatBodyContentNew = styled.div<ChatBodyContentProps>`
    height: ${(props) => (props.heightValue ? props.heightValue : '100%')};
    flex-direction: column;
    overflow-y: scroll;
    display: flex;
    width: 100%;
`;

export const NoMessagesContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
`;
